import React from "react";
import { react } from "mobx";
import { inject, observer } from "mobx-react";
import {Alert, Button, Form, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledAlert} from "reactstrap";
import {Component} from "react/lib/ReactBaseClasses";
import store from "../../../stores";
import loading from '../../../assets/images/ajax-loader.gif';
import FormErrorsStore from "../stores/FormErrorsStore";

@inject("store")
@observer
class FormErrors extends Component {

    constructor(props) {
        super(props);
        this.formErrorsStore          = this.props.controller;
    }

    render() {
        return (
            <div>
                {this.formErrorsStore.errors && this.formErrorsStore.errors.length > 1 && _.uniq(this.formErrorsStore.errors).map(
                    (error, i) => {
                        if(error) {
                            return <Alert key={i} color="danger">
                                {error}
                            </Alert>
                        }
                    }
                )}
            </div>
        );
    }
}

export {FormErrors}